import React from 'react'
import { Container, Row, Col } from "react-bootstrap";

function PartnerProgram() {
    return (
        <section class="program">
      <Container>
        <Row>
          <div class="col-lg-12">
            <div class="part-program d-flex">
              <div class="part-program__text part-program-text">
                <div class="part-program-text__title">
                  Партнерская программа
                </div>
                <div class="part-program-text__subtitle">
                  Приглашайте покупателей и продавцов, получайте деньги на счет!
                </div>
              </div>
              <div class="part-program__img">
                <img src="img/gentelmen.png" alt="img" />
              </div>
            </div>
            <div class="program__secondtext">
              <div class="programsecond-title">
                Поделитесь ссылкой
              </div>
              <div class="programsecond-invite d-flex">
                <div class="programsecond-text">
                  Приглашайте людей и получайте деньги!
                </div>
                <div class="programsecond-referral">
                  <a href="#">Redslon.ru/?ref=ersk295nf7</a>
                </div>
              </div>
            </div>
            <div class="program__info">
              <div class="program-info__title">
                Ваша статистика
              </div>
              <div class="program-info__items d-flex">
                <div class="program-info__item d-flex">
                  <div class="program-info-item__img">
                    <img src="img/programuser.svg" alt="img" />
                  </div>
                  <div class="program-info-item__text d-flex">
                    <div class="program-info-item__title">
                      Зарегистрировано пользователей
                    </div>
                    <div class="program-info-item__sum">
                      0 чел.
                    </div>
                  </div>
                </div>
                <div class="program-info__item d-flex">
                  <div class="program-info-item__img">
                    <img src="img/programbank.svg" alt="img" />
                  </div>
                  <div class="program-info-item__text d-flex">
                    <div class="program-info-item__title">
                      Выплат на сумму
                    </div>
                    <div class="program-info-item__sum">
                      0 чел.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="program-money">
              <div class="program-money__items d-flex">
                <div class="program-money-item d-flex">
                  <img src="img/program1uotline.svg" alt="out" />
                  <div class="program-money-item__text rightstr">
                    Приводи продавцов и покупателей
                  </div>
                </div>
                <div class="program-money-item d-flex">
                  <img src="img/program2outline.svg" alt="out" />
                  <div class="program-money-item__text top1">
                    Зарабатывай со сделок
                  </div>
                </div>
                <div class="program-money-item d-flex">
                  <img src="img/program3outline.svg" alt="out" class="top" />
                  <div class="program-money-item__text top2">
                    Выводи деньги
                  </div>
                </div>
              </div>
            </div>
            <div class="program-text">
              <div class="program-text__title">
                3% на баланс от всех сделок приглашенных покупателей и
                продавцов, если сумма сделки менее 100$ и 2% если более 100$
              </div>
              <div class="program-text__subtitle">
                *При условии что в сделке участвует только один участник
                партнерской программы, в случае когда в сделке каждый участник
                кем-то приглашен, процент делится на двоих.
              </div>
              <div class="program-text__subtext">
                <span>Внимание:</span> При использовании партнерской программы
                для снижения комиссии самому себе, вы можете получить блокировку
                и потерять деньги!
              </div>
            </div>
          </div>
          </Row>
        </Container>
      </section>
    )
}

export default PartnerProgram
